var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.11875 1.28859L5.99875 5.16859L9.87875 1.28859C10.2688 0.898594 10.8988 0.898594 11.2888 1.28859C11.6788 1.67859 11.6788 2.30859 11.2888 2.69859L6.69875 7.28859C6.30875 7.67859 5.67875 7.67859 5.28875 7.28859L0.69875 2.69859C0.30875 2.30859 0.30875 1.67859 0.69875 1.28859C1.08875 0.908594 1.72875 0.898594 2.11875 1.28859Z",
    fill: "#282860"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.915a387758a7a79e18245702651d240c.svg";
export { ForwardRef as ReactComponent };